module.exports = __webpack_public_path__ + "img/18.d771f956.jpg";